import React, { useState } from "react";
import tutifyLogo from "../../assets/images/Logo.png";
import styles from "./style.module.css";
import { AiOutlineSearch } from "react-icons/ai";
import { RiLogoutCircleLine } from "react-icons/ri";
import { IoSettingsSharp } from "react-icons/io5";
import { NavLink } from "react-router-dom";
import { routeConfig } from "../sidebar/sidebar";
import { Popover } from "antd";
import userIcon from "../../assets/images/user-icon-removebg.png";
import { useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { deleteUser } from "../../redux/slice/auth/authSlice";
import { clearAuthToken } from "../../helper/utils";

const Header = () => {
  const [isNavbarCollapsed, setIsNavbarCollapsed] = useState(true);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const handleNavbarToggle = () => {
    setIsNavbarCollapsed(!isNavbarCollapsed);
  };
  const popoverContent = () => (
    <div className="text-center">
      <button
        className="btn btn-sm text-secondary border-0"
        onClick={() => {
          navigate("/profile-setting");
          // console.log("Setting clicked");
        }}
      >
        <IoSettingsSharp className="me-2" />
        Setting
      </button>
      <br />
      <button
        className="btn btn-sm text-secondary border-0"
        onClick={() => {
          navigate("/");
          // console.log("Logout clicked");
          dispatch(deleteUser());
          clearAuthToken();
        }}
      >
        <RiLogoutCircleLine className="me-2" />
        Logout
      </button>
    </div>
  );

  return (
    <nav
      className={`navbar ${styles.customBGColor} navbar-expand-lg position-sticky fixed-top`}
    >
      <div className="container-fluid px-5">
        <a className="navbar-brand" href="/">
          <img src={tutifyLogo} alt="Tutify Logo" width={100} />
        </a>
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarSupportedContent"
          aria-controls="navbarSupportedContent"
          aria-expanded={!isNavbarCollapsed}
          aria-label="Toggle navigation"
          onClick={handleNavbarToggle}
        >
          <span className="navbar-toggler-icon"></span>
        </button>
        <div
          className={`collapse navbar-collapse ${
            isNavbarCollapsed ? "" : "show"
          }`}
          id="navbarSupportedContent"
        >
          <div className="me-auto"></div>
          <ul className="navbar-nav me-auto d-lg-none d-block d-md-block">
            {routeConfig.map((route, key) => (
              <li className="nav-item" key={key}>
                <NavLink className="nav-link fs_12" to={route.path}>
                  <route.icon size={25} /> {route.name}
                </NavLink>
              </li>
            ))}
          </ul>

          <form className="d-flex" role="search">
            <div className="d-flex bg-white me-2 my-1 shadow-sm">
              {/* <input
                type="search"
                className="form-control fs_12 border-0 form_control_focus_box_shadow_none"
                placeholder="Search"
                aria-label="Username"
                aria-describedby="basic-addon1"
              /> */}
              {/* <AiOutlineSearch className={`${styles.searhIcon}`} /> */}
            </div>
          </form>

          {/* Profile */}
          <Popover
            content={popoverContent} // Customize the content function as needed
            trigger="hover"
          >
            <img
              src={userIcon}
              alt="Warning / Blocked"
              style={{ cursor: "pointer", width: "30px" }}
            />
          </Popover>
          {/* <div className="d-flex">
            <ul className="p-0 d-flex m-0">
              <li className="nav-item mt-1 mb-1 list-unstyled">
                <button
                  type="button"
                  className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
                >
                  SIGN IN
                </button>
              </li>
              <li className="nav-item mt-1 mb-1 list-unstyled">
                <button
                  type="button"
                  className="btn btn-primary text-uppercase btn-sm me-2 btn_contained_black"
                >
                  SIGN UP
                </button>
              </li>
              <li className="nav-item mt-1 mb-1 list-unstyled">
                <button
                  type="button"
                  className="btn btn-primary text-uppercase btn-sm btn_contained_black"
                >
                  BECOME A TEACHER
                </button>
              </li>
            </ul>
          </div> */}
        </div>
      </div>
    </nav>
  );
};

export default Header;
